
class JWTAuthenticationProvider {
    constructor(config, provider) {
        this.storageId = "auth";
        this.provider = provider;

    }

    async isAuthenticated() {

        return new Promise((resolve, reject) => {
            if (this.hasTokens) {
                if (this.isTokenExpired()) {
                    console.log("token is expired")
                    this.refreshTokens()
                        .then(() => {
                            console.log("isAuthenticated.provider.refreshTokens.resolve")
                            resolve();
                        })
                        .catch((e) => {
                            console.log("isAuthenticated.provider.refreshTokens.reject")
                            reject();
                        })
                } else {
                    
                    // testing authenticity of token.
                    this.provider.authorize(this.tokens)
                        .then(() => {
                            console.log("isAuthenticated.provider.authorize.resolve")
                            resolve();
                        })
                        .catch(e => {
                            console.log("isAuthenticated.provider.authorize.reject")
                            console.log(e);
                            reject();
                        })
                }
            }
            else {
                reject();
            }
        })
    }


    get tokens() {
        return app.authentication.userData.getData().data
    }

    get hasTokens() {
        return app.authentication.userData.getData().data.hasOwnProperty("token");
    }

    get roles () {
        return app.authentication.userData.getData().roles
    }

    setTokens({token, refreshToken}) {

        try {
            console.log("setTokens called", token, refreshToken)
            const payload = JSON.parse(atob(token.split(".")[1]));;
            const userData = {

                username: payload.name,
                roles: payload.roles,

                data: {
                    token,
                    refreshToken
                }
            }

            app.authentication.userData.setData(userData)
            
        }catch(e) {
            console.error(e);
        }
    }

    removeTokens() {
        app.authentication.userData.deleteData();
    }

    login(options) {
        const { username, password } = options;
        return new Promise((resolve, reject) => {
            this.provider.loginPassword({ username, password })
                .then(tokens => {
                    // 200
                    this.setTokens(tokens);
                    console.log("setting tokens", app.authentication.userData.getData().username);
                    resolve(true);
                })
                .catch(e => {
                    // 403
                    this.removeTokens();
                    reject(false);
                })
        })
    }

    logout() {
        this.removeTokens();
        return Promise.resolve();
        // TODO: proberly need to redirect user to frontpage here.
    }

    async refreshTokens() {
        return new Promise((resolve, reject) => {
            if (this.hasTokens) {
                this.provider.loginToken(this.tokens)
                    .then(newTokens => {
                        // 200
                        this.setTokens(newTokens);
                        resolve(true);
                    })
                    .catch(e => {
                        //403
                        this.removeTokens();
                        reject(false);
                    })
            }
            else {
                reject(false);
            }
        })
    }

    payload() {
        return JSON.parse(atob(this.tokens.token.split(".")[1]));;
    }

    isTokenExpired() {
        return new Date().getTime() > new Date(this.payload().iat);
    }

    user() {
        return this.tokens
    }
}

AuthenticationProvider.add("JWTStub", (config) => {
    // TODO: this needs to use the correct prvider and not the stub
    return new JWTAuthenticationProvider(config, new AuthApiStub({
        returnToken: "user1"
    }));
});





class AuthApiStub {
    constructor(options) {
        this.defaultOptions = {
            login_token_will_succeed: true,
            authorize_token_will_succeed: true,
            expiresIn: 1,
            returnToken: null,
            tokens: {
                root: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6InJvb3QiLCJpYXQiOjE1MTYyMzkwMjIsInJvbGVzIjpbImFkbWluIiwidXNlcjEiLCJ1c2VyMiJdfQ.Hv1JywszjEGcwbdEMqW2jx3gaTzVfM2G1ZgbAdRp6Xg",
                admin: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvZSB0aGUgYWRtaW4iLCJpYXQiOjE1MTYyMzkwMjIsInJvbGVzIjpbImFkbWluIl19.OXGkVIjIKTDLOdZuuWw2jG2d3tJLd9GDdV9cUKv0jeI",
                user1: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6InVzZXIxIiwiaWF0IjoxNTE2MjM5MDIyLCJyb2xlcyI6WyJ1c2VyMSJdfQ.w8PNXej8cz0YuhZ0ysOG_6iO1N6v5jXac7Vs3-m6z7A",
                user2: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6InVzZXIyIiwiaWF0IjoxNTE2MjM5MDIyLCJyb2xlcyI6WyJ1c2VyMiJdfQ.GIsuge6RdOmK1IRa6eoDkd7zFgewnTavlBVJ344o5dg"
            },
            users: [
                { email: "root@email.com",  "password": "123", returnToken: "root" },
                { email: "admin@email.com", "password": "123", returnToken: "admin" },
                { email: "user1@email.com", "password": "123", returnToken: "user1" },
                { email: "user2@email.com", "password": "123", returnToken: "user2" }
            ]
        }
        this.options = Object.assign({}, this.defaultOptions, options);
    }


    addMinutes(date, minutes) {
        return new Date(date.getTime() + minutes * 60000);
    }


    async loginPassword(options) {
        // Looking through our pre generated test tokens to find a match.
        var result = this.options.users.find(e => e.email === options.username);
        if (result) {
            // We are unpacking the tokens and adding an expire date
            // this is ofc invalidating the tokens, bc the signature would
            // not match... but this is just a stub so we never actually 
            // hit a server so its fine.
            let token = this.options.tokens[result.returnToken].split(".");
            let head = token[0];
            let payload = JSON.parse(atob(token[1]));
            let sig = token[2];
            payload.iat = this.addMinutes(new Date(), this.options.expiresIn || 0).getTime();
            let returnToken = `${head}.${btoa(JSON.stringify(payload))}.${sig}`;
            return Promise.resolve({
                status: 200,
                token: returnToken,
                refreshToken: `fake-refresh-token-${new Date().getTime()}`
            })
        }
        return Promise.reject({ status: 403 });
    }
    async loginToken(tokens) {

        console.log("loginToken called", tokens)
        if (this.options.login_token_will_succeed) {
            let token = tokens.token.split(".");
            let head = token[0];
            let payload = JSON.parse(atob(token[1]));
            let sig = token[2];
            payload.iat = this.addMinutes(new Date(), 5).getTime();
            let returnToken = `${head}.${btoa(JSON.stringify(payload))}.${sig}`;
            // status code: 200
            return Promise.resolve({
                token: returnToken,
                refreshToken: `fake-refresh-token-${new Date().getTime()}`
            })
        } else {
            // status code: 403
            return Promise.reject();
        }
    }
    async authorize(tokens) {
        console.log("authorize called")
        if (this.options.authorize_token_will_succeed) {
            // the token is valid
            return Promise.resolve(200);
        } else {
            // NOTE: 
            // the token is not valid
            // we should attempt to authorize with the refresh token.. 
            // but this is missing from the flow.. 
            return Promise.reject(401);
        }
    }

}




